<template>
    <div
            v-if="event"
            class="card"
    >
        <booking-summary
                :event="event"
                :booking="booking"
        ></booking-summary>

        <div class="card-body">
            <h2 class="card-text mb-3">
              {{ $t('chooseYourZone') }}:
            </h2>

            <button
                    v-for="zone in event.zones"
                    v-bind:key="zone"
                    class="btn btn-secondary btn-block text-left"
                    @click="setZone(zone)"
            >
                {{ zone }}
            </button>
        </div>

        <locker-company-logo></locker-company-logo>
    </div>
</template>

<script>
    import BookingSummary from '../components/BookingSummary';
    import LockerCompanyLogo from '../components/LockerCompanyLogo';
    import translationMixin from '../mixins/translationMixin';
    import eventBus from '../eventBus';

    export default {
        mixins: [translationMixin],

        components: {
            BookingSummary,
            LockerCompanyLogo
        },

        props: [
            'event',
            'booking'
        ],

        methods: {
            /**
             * Set the zone and proceed.
             *
             * @param {String} zone
             */
            setZone(zone) {
                this.booking.preferred_zone = zone;
                this.booking.can_select_zone = true;

                // Trigger a reload of event to get zone capacity
                eventBus.$emit('reloadEvent');

                // To periods/lockers
                this.$router.push('/event/' + this.event.code);
            }
        }
    }
</script>
